import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Button as ANTButton, Form, Input, notification } from 'antd';
import { createCustomer, updateCustomer } from 'api/subscriptions';

const CreateCustomer = ({ handleOpen, refetch, customerData, isEdit }) => {
  const [isCustomerAdding, setIsCustomerAdding] = useState(false);
  const store = useSelector((state) => state.company.store);
  const userStores = useSelector((state) => state?.company?.userStores);

  const onAddSubmit = async (values) => {
    if (userStores?.length > 1 && !store?.isSelected && !isEdit) {
      notification.error({ message: 'Select store from the drop-down menu above', placement: 'bottomRight' });
      return;
    }
    setIsCustomerAdding(true);
    const { firstName, lastName, email, phone } = values;

    const payload = {
      ...(!isEdit && { email: email }),
      phone: phone,
      first_name: firstName,
      last_name: lastName,
    };
    const response = isEdit ? await updateCustomer(customerData?.store_id, customerData?._id, payload) : await createCustomer(store?._id, payload);
    if (response?.data?.success) {
      handleOpen();
      refetch();
    }
    setIsCustomerAdding(false);
  };

  const initialValues = isEdit && {
    firstName: customerData?.first_name,
    lastName: customerData?.last_name,
    email: customerData?.email,
    phone: customerData?.phone,
  };

  return (
    <div className='formDetails'>
      <Form layout='vertical' onFinish={onAddSubmit} initialValues={initialValues}>
        <div className='create-form'>
          <Form.Item
            name='firstName'
            label='First Name'
            className={`customInput mobileInputView ${isEdit ? '' : 'steric-after'}`}
            rules={[
              !isEdit && {
                required: true,
                message: 'First Name is required',
              },
              {
                validator: (_, value) => {
                  if (!value) return Promise.resolve();
                  const regex = /^[^%?{}[\]$^@<>\"&!:;~*]+$/;
                  if (regex.test(value)) {
                    return Promise.resolve();
                  } else {
                    return Promise.reject('%?{}[]$^@<>"&!:;~* are not allowed.');
                  }
                },
              },
            ].filter(Boolean)}>
            <Input type='string' placeholder='Enter first name' name='firstName' />
          </Form.Item>
          <Form.Item
            name='lastName'
            label='Last Name'
            className={`customInput mobileInputView ${isEdit ? '' : 'steric-after'}`}
            rules={[
              !isEdit && {
                required: true,
                message: 'Last Name is required',
              },
              {
                validator: (_, value) => {
                  if (!value) return Promise.resolve();
                  const regex = /^[^%?{}[\]$^@<>\"&!:;~*]+$/;
                  if (regex.test(value)) {
                    return Promise.resolve();
                  } else {
                    return Promise.reject('%?{}[]$^@<>"&!:;~* are not allowed.');
                  }
                },
              },
            ].filter(Boolean)}>
            <Input type='string' placeholder='Enter last name' name='lastName' />
          </Form.Item>
          <Form.Item
            name='email'
            label='Email'
            className={`customInput mobileInputView ${isEdit ? '' : 'steric-after'}`}
            rules={[
              {
                required: true,
                message: 'Email is required',
              },
              {
                type: 'email',
                message: 'Please enter a valid email address',
              },
            ]}>
            <Input disabled={isEdit} placeholder='Enter email' name='email' className='input-placeholder' />
          </Form.Item>
          <Form.Item
            name='phone'
            label='Phone'
            className={`customInput mobileInputView ${isEdit ? '' : 'steric-after'}`}
            rules={[
              {
                required: true,
                message: 'Phone number is required',
              },
              {
                type: 'string',
                message: 'Please enter a valid phone number',
              },
            ]}>
            <Input placeholder='Enter phone number' name='phone' className='input-placeholder' />
          </Form.Item>
        </div>

        <div className='mb-[-20px] form_button update-button'>
          <Form.Item>
            <div style={{ display: 'flex', justifyContent: 'right' }}>
              <ANTButton block className='rounded-lg' onClick={() => handleOpen()}>
                Cancel
              </ANTButton>
              <Button block className='button-theme ml-4 rounded-lg' htmlType='submit' loading={isCustomerAdding}>
                {isEdit ? 'Update' : 'Add'}
              </Button>
            </div>
          </Form.Item>
        </div>
      </Form>
    </div>
  );
};

export default CreateCustomer;
